import React from 'react';
import { frcApplicationListFilter, frcToDoFilter } from './components';
import { ASSESSMENT_HOME_PAGE_TEXT } from '../lang';
import { useAuth } from '../../../contexts/authContext/authContext';
import {
  useGetApplicationNumbers,
  type AdvancedFilter,
} from '../../Nomination/graphql/SupervisorHomePage';
import {
  type ManagementCardInfo,
  HomePage,
  Loading,
  Alert,
} from '../../../components';

const assessmentHomeCards: ManagementCardInfo[] = [
  {
    title: ASSESSMENT_HOME_PAGE_TEXT.TO_DO_LIST,
    caseName: ASSESSMENT_HOME_PAGE_TEXT.APPLICATIONS,
    caseNumber: 0,
    backgroundColor: '#951D1D',
    navLink: 'frc-homepage/frcassessments?am=0',
  },
  {
    title: ASSESSMENT_HOME_PAGE_TEXT.APPLICATION_LIST,
    caseName: ASSESSMENT_HOME_PAGE_TEXT.APPLICATIONS,
    caseNumber: 0,
    backgroundColor: '#D96422',
    navLink: 'frc-homepage/frcassessments?am=1',
  },
];
export const FRCAssessmentHomePage: React.FunctionComponent = () => {
  const { user } = useAuth();

  const assessmentHomePageFilter: AdvancedFilter[] = [
    frcToDoFilter(user),
    frcApplicationListFilter(user),
  ];

  const { applicationNumbers, loading, error } = useGetApplicationNumbers(
    assessmentHomePageFilter,
  );

  assessmentHomeCards.forEach((card, index) => {
    card.caseNumber = applicationNumbers?.[index];
  });

  if (error) {
    return (
      <Alert
        openAlert={true}
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent: 'Error Occurs.' + (error as Error)?.message,
          alertType: 'error',
        }}
      />
    );
  }

  return loading ? (
    <Loading />
  ) : (
    <HomePage managementCards={assessmentHomeCards} />
  );
};
